import { $post,$get,$axiosDelete,$put } from "../util/request"
import { $debounce } from "../util/util"
// import { $cfm,$ms,$me,$mi,$mw,$validate } from "../util/antUtil"

export default (Vue) => {
    Vue.mixin({
        data() {
            return {
                test: "自用插件测试数据"
            }
        },
        methods: {
            // request.js
            $post,
            $get,
            $axiosDelete,
            $put,
            // util.js
            $debounce,
            // antUtil.js
            // $cfm,
            // $ms,
            // $me,
            // $mi,
            // $mw,
            // $validate
        }
    })
}